import { render, staticRenderFns } from "./bet-error-popup.vue?vue&type=template&id=84be8bb0"
import script from "./bet-error-popup.vue?vue&type=script&lang=js"
export * from "./bet-error-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84be8bb0')) {
      api.createRecord('84be8bb0', component.options)
    } else {
      api.reload('84be8bb0', component.options)
    }
    module.hot.accept("./bet-error-popup.vue?vue&type=template&id=84be8bb0", function () {
      api.rerender('84be8bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/bet-error-popup.vue"
export default component.exports